export const BACKGROUND_COLOR_EXPERIMENT = 'backgroundColor';
export const GLADLY_CHAT_FLAGSHIP_KEY = 'GLADLY_CHAT';
export const BRIGHTBACK_CANCEL_KEY = 'BRIGHTBACK_CANCEL_BUTTON';
